import { useEffect, useState } from "react"
import "./PublishDraftSwitch.css"

const PublishDraftSwitch = ({
  initialValue = false, // false = draft, true = published
  onToggle = () => {},
  trueLabel = "Published",
  falseLabel = "Draft",
  trueIcon = "bx-check-shield",
  falseIcon = "bx-edit-alt",
}) => {
  const [isPublished, setIsPublished] = useState(initialValue)

  useEffect(() => {
    setIsPublished(initialValue)
  }, [initialValue])

  const handleChange = () => {
    const newValue = !isPublished
    setIsPublished(newValue)
    onToggle(newValue)
  }

  return (
    <div className="publish-switch" onClick={handleChange}>
      <div
        className={`switch-track ${
          isPublished ? "active bg-success" : "bg-secondary"
        }`}
      >
        <div className="switch-thumb">
          <i
            className={`bx ${
              isPublished
                ? `${trueIcon} text-success`
                : `${falseIcon} text-secondary`
            }`}
          ></i>
        </div>
      </div>
      <span className={`status-label ${isPublished ? "published" : "draft"}`}>
        {isPublished ? trueLabel : falseLabel}
      </span>
    </div>
  )
}

export default PublishDraftSwitch
